import { CatalogItem } from '../CatalogItem';
import { normalizeQuery } from './catalogQueryNormalizer';

export function catalogSearchByKeyword(query: string, items: CatalogItem[]) {
  const results: CatalogItem[] = [];
  const normalizedQuery = normalizeQuery(query);
  for (const item of items) {
    const normalizedItemLabel = normalizeQuery(item.label);
    if (normalizedItemLabel.includes(normalizedQuery)) {
      results.push(item);
    }
  }
  return results;
}
